import React, { useRef } from "react"
import { Button, Card, Input, Alert } from "antd"

// Styles
import styles from '../../index.module.css'

const TripChecklistHomepage = ({ 
    checkICNumberHDLR, 
    success, 
    wordings = {}
}) => {

    const inputRef = useRef(null)

    const onSubmit = () => {
        const value = inputRef.current.input.value

        checkICNumberHDLR(value)
    }

    return (
        <>
            {
                success
                &&
                <Alert 
                    style={{ margin: 18 }}
                    type={"success"}
                    message={
                        <div>
                            <b>Checklist Submitted Successfully!</b><br />
                            <span>Your inspection has been recorded.</span>
                        </div>
                    }
                    banner
                />
            }
            <Card style={{ margin: 18 }}>
                <h3>{wordings.ident_title}</h3>
                <h5>{wordings.ident_subtitle}</h5>
                <Input ref={inputRef} />
                <Button onClick={onSubmit} className={styles["button-submit"]}>Submit</Button>
            </Card>
            <Card style={{ margin: 18 }}>
                <h3>{wordings.howto_title}</h3>
                <ol>
                    {
                        wordings.howto_list?.map((list, i) => <li key={i}>{list}</li>)
                    }
                </ol>
            </Card>
        </>
    )
}

export default React.memo(TripChecklistHomepage)